/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import Axios from "axios";
import { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import DashboardContext from "../../../../Context";
import { Table } from "antd";

const ModalCustomerWalletDetailReport = ({
  showitem,
  handleCloseMoudal,
  userId,
  walletType,
  fromDate,
  toDate,
  headerTitle,
  handleRefreshGridWorker,
}) => {

  const { sideBardata, authentication, urldashboard } =
    useContext(DashboardContext);

  const [loading, setLoading] = useState(true);
  const [totoalRecord, setTotalRecord] = useState(0);
  const [data, setDataFech] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 20,
  });

  const datafeching = async ({ page, pageSize }) => {

    try {

      let url = `/CustomerWallet/Get`;

      const res = await Axios.post(urldashboard + url, JSON.stringify({
        page,
        pageSize,
        fromCreateDate: fromDate,
        toCreateDate: toDate,
        userId,
        walletType
      }), {
        headers: {
          "Authorization": authentication,
          "Content-Type": "application/json"
        }
      })

      const data = await res.data

      setDataFech(data.data)

      setTotalRecord(data.totalRecord)

      setPagination({
        page: page,
        pageSize: pageSize,
        total: data.totalRecord, // 200 is mock data, you should read it from server
        // total: data.totalCount,
      });

      setLoading(false);
    } catch (error) {
      setLoading(false);
      alert('خطایی رخ داده است!')
      setDataFech([]);
    }
  }

  const handleTableChange = (newPagination, filters, sorter) => {
    datafeching({
      page: newPagination.current,
      pageSize: newPagination.pageSize,
      fromDate: fromDate,
      toDate: toDate
    });
  };

  useEffect(() => {

    datafeching({ page: 1, pageSize: 20 })

    return () => { };
  }, [userId]);

  const columns = [
    {
      title: 'ردیف',
      dataIndex: 'index',
      key: 'index',
      width: '1%',
      render: (item, record, index) => (<>{(index + 1) + ((pagination?.page - 1) * pagination?.pageSize)}</>)
    },
    {
      title: 'مبلغ',
      dataIndex: 'amount',
      key: 'amount',
      render: (item, record, index) => (item.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
    },
    {
      title: 'زمان',
      dataIndex: 'persianCreateDate',
      key: 'persianCreateDate',
    }
  ];

  return (
    <div>
    <Modal show={showitem} onHide={handleCloseMoudal} size={"lg"}>
      <Modal.Header style={{backgroundColor:'rgb(235 150 84)'}}>
      <Modal.Title>جزئیات {headerTitle}</Modal.Title>
        <i
          className="fa fa-times mr-auto"
          style={{ fontSize: "16px", cursor: "pointer" }}
          onClick={handleCloseMoudal}
          aria-hidden="true"
        ></i>
      </Modal.Header>

      <Modal.Body>

        <Table
          size="small"
          style={{ textAlign: 'right', marginTop: 20 }}
          rowClassName={(row, index) => 'center'}
          columns={columns}
          bordered={true}
          //rowKey={(record) => record.login.uuid}
          dataSource={data}
          pagination={pagination}
          loading={loading}
          onChange={handleTableChange}
        // expandable={{
        //     expandedRowRender: record => <p style={{ margin: 0 }}>{record.customerName}</p>,
        //     rowExpandable: record => record.customerName !== 'Not Expandable',
        // }}
        />
        <div style={{ marginTop: -40 }}>
          تعداد کل:{totoalRecord}
          <br />
          {/* جمع کل فروش:{totoalAmountSale.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") } */}
        </div>

      </Modal.Body>

      <Modal.Footer style={{backgroundColor:'rgb(235 150 84)'}}>

      </Modal.Footer>

    </Modal>
    </div>

  );
};

export default ModalCustomerWalletDetailReport;
